import React, { useEffect, useState } from "react";
import SelectBox from "components/comman/SelectBox";
import { Images } from "constants/Images";
import DataTable from "react-data-table-component";
import "stylesheets/createQuotationProjectForm.scss";
import CreateProjectModal from "components/modal/CreateProjectModal";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import moment from "moment";
import { GoCalendar } from "react-icons/go";
import ModalC from "components/comman/ModalC";
import cal from "assets/icons/calendar.svg";
import { API } from "API/API";
import ClipLoader from "react-spinners/ClipLoader";
import { toast } from "react-toastify";
import { propTypes } from "react-bootstrap/esm/Image";
import { useAuthContext } from "context/auth/AuthContext";
import { useSearchContext } from "context/searchContext/searchContext";
import Button from "components/button";
import cross from "assets/icons/cross.svg";
import QuotationProjectModal from "components/modal/QuotationProjectModal";
import { FaLeaf } from "react-icons/fa";
import { FaFilePdf } from "react-icons/fa";
import RenameProjectModal from "components/modal/RenameProjectModal";

// const shortBy = [
//   {
//     id: 1,
//     value: "Most Recent",
//     type: "-createdAt",
//   },
//   {
//     id: 2,
//     value: "Name",
//     type: "name",
//   },
//   {
//     id: 3,
//     value: "Product/Result",
//     type: "-name",
//   },
// ];

const shortBy = [
  {
    id: 1,
    value: "Most Recent",
    type: "recents",
  },
  {
    id: 2,
    value: "Name",
    type: "name",
  },
  {
    id: 3,
    value: "Result",
    type: "result",
  },
];

export const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

const CreateQuotationProjectForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [modal, setModal] = useState(false);
  const [tData, setTData] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [loader, setLoader] = useState(false);
  const [show, setShow] = useState(false);
  const [cloneShow, setCloneShow] = useState(false);
  const [quotationProjectModal, setQuotationProjectModal] = useState(false);

  const [tokenMain, setTokenMain] = useState("");

  const [sortByName, setSortByName] = useState(null);
  const [rowId, setRowId] = useState(null);
  const [ClonerowId, setClonerowId] = useState(null);

  const { doLogin, assignToken, login, token } = useAuthContext();
  const { mapUserData } = useSearchContext();

  const [searchBar, setSearchBar] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  // Add pagination state from API response
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const [statusCounts, setStatusCounts] = useState({
    draft: 0,
    check: 0,
    closed: 0
  });
  const [sortBy, setSortBy] = useState("recents");

  const [renameModalShow, setRenameModalShow] = useState(false);
  const [selectedProjectForRename, setSelectedProjectForRename] = useState(null);
  const [renameLoading, setRenameLoading] = useState(false);

  const debouncedSearchTerm = useDebounce(searchBar, 500);

  useEffect(() => {
    if (location?.search)
      getMainUser(location?.search?.slice(1));
  }, [location?.search]);

  // Updated useEffect to properly handle pagination
  useEffect(() => {
    if (token) {
      getCalculatorConfigurationData(debouncedSearchTerm, page, limit, sortBy);
      if (!debouncedSearchTerm) {
        getStatusCounts();
      }
    }
  }, [token, page, limit, debouncedSearchTerm, sortBy]);

  const getMainUser = async (tokenA) => {
    try {
      let response = await API.UserProfile(tokenA);
      if (response.data) {
        localStorage.removeItem("mytoken");
        localStorage.setItem("mytoken", tokenA);
        assignToken(tokenA);

        const data = response.data;
        mapUserData(data);
        doLogin(true);
      } else {
        toast.error("Login failed");
      }
    } catch (error) {
      console.error("Login error:", error);
      toast.error("Login failed");
    }
  };

  const getStatusCounts = async () => {
    try {
      const response = await API.getCalculatorStatusCount(token);

      if (response.success && response.data) {
        setStatusCounts({
          draft: response.data.DRAFT || 0,
          check: response.data.CHECK || 0,
          closed: response.data.CLOSED || 0
        });
      }
    } catch (error) {
      console.error("Error fetching status counts:", error);
    }
  };

  // Updated function to properly handle pagination parameters
  // const getCalculatorConfigurationData = async (searchTerm = "", pageNum = 1, pageLimit = 10) => {
  //   setLoader(true);
  //   try {
  //     // Pass all pagination parameters to API
  //     const response = await API.getCalculatorConfigurations(token, pageNum, pageLimit, searchTerm);
  //     console.log("Calculator configurations:", response);

  //     if (response.success && response.data.configurations) {
  //       // Transform the API data to match your table structure
  //       const transformedData = response.data.configurations.map((config) => ({
  //         _id: config._id,
  //         name: config.step1?.projectName || "Unnamed Project",
  //         projectType: config.step1?.constructionType || "Calculator",
  //         startDate: moment(config.createdAt).format("MMM D, YYYY"),
  //         location: config.step1?.address ?
  //           `${config.step1.address.city}, ${config.step1.address.state}` : "N/A",
  //         status: config.status || "DRAFT",
  //         lastStepCompleted: config.lastStepCompleted,
  //         originalData: config
  //       }));

  //       setProjectList(transformedData);

  //       // Update pagination state from API response
  //       if (response.data.pagination) {
  //         setTotalItems(response.data.pagination.totalItems);
  //         setTotalPages(response.data.pagination.totalPages);
  //         setCurrentPage(response.data.pagination.currentPage);
  //       }
  //     } else {
  //       toast.error(response.message || "Failed to fetch calculator configurations");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching calculator configurations:", error);
  //   } finally {
  //     setLoader(false);
  //   }
  // };

  const getCalculatorConfigurationData = async (searchTerm = "", pageNum = 1, pageLimit = 10, sortByParam = "recents") => {
    setLoader(true);
    try {
      // Pass sortBy parameter to API
      const response = await API.getCalculatorConfigurations(token, pageNum, pageLimit, searchTerm, sortByParam);
      console.log("Calculator configurations:", response);

      if (response.success && response.data.configurations) {
        const transformedData = response.data.configurations.map((config) => ({
          _id: config._id,
          name: config.step1?.projectName || "Unnamed Project",
          projectType: config.step1?.constructionType || "Calculator",
          startDate: moment(config.createdAt).format("MMM D, YYYY"),
          location: config.step1?.address ?
            `${config.step1.address.city}, ${config.step1.address.state}` : "N/A",
          status: config.status || "DRAFT",
          lastStepCompleted: config.lastStepCompleted,
          projectPdf: config.projectPdf || null,
          originalData: config
        }));

        setProjectList(transformedData);

        if (response.data.pagination) {
          setTotalItems(response.data.pagination.totalItems);
          setTotalPages(response.data.pagination.totalPages);
          setCurrentPage(response.data.pagination.currentPage);
        }
      } else {
        toast.error(response.message || "Failed to fetch calculator configurations");
      }
    } catch (error) {
      console.error("Error fetching calculator configurations:", error);
    } finally {
      setLoader(false);
    }
  };

  const [deleteLoader, setDeleteLoader] = useState(false);
  const [cloneLoader, setcloneLoader] = useState(false);

  const [sortType, setSortType] = useState([]);
  const [modalRowData, setModalRowData] = useState({});

  const onCreareProject = () => {
    setModalRowData({});
    setModal(!modal);
  };

  const onDetailPage = (item) => {
    navigate("/project-detail", { state: { item } });
  };

  const { handleSubmit, control, setValue, getValue } = useForm({});
  const { setProjectName, CurrentprojectData } = useSearchContext();

  const ProjectdeleteData = async () => {
    setDeleteLoader(true);
    try {
      const response = await API.deleteCalculatorConfiguration(rowId, token);

      if (response.success) {
        // Refresh current page data
        getCalculatorConfigurationData(debouncedSearchTerm, page, limit, sortBy);
        getStatusCounts();
        toast.success(response.message || "Calculator project deleted successfully");
      } else {
        toast.error(response.message || "Failed to delete calculator project");
      }
    } catch (e) {
      toast.error("Network Error");
    } finally {
      setDeleteLoader(false);
      setShow(false);
    }
  };

  const handleDownloadPdf = (row) => {
    if (!row.projectPdf) {
      toast.error("PDF not available for this project");
      return;
    }
    // Strip /api/v1 from the base URL to get the server root
    const serverBase = "http://mifab-backend.ourappdemo.com:4000";
    // const serverBase = "http://mifab-backend.ourappdemo.com:4000"

    const pdfUrl = `${process.env.REACT_APP_IMAGE_BASEURL?.replace(/\/product-image\/?$/, "")}${row.projectPdf}`;
    window.open(pdfUrl, "_blank");
  };



  const handleClose = () => {
    setShow(false);
  };

  const handlecloneClose = () => {
    setCloneShow(false);
  };

  const handleProjectClick = (row, forceStep1 = false) => {
    if (!forceStep1 && row.status === "CLOSED") {
      navigate('/project-results', {
        state: {
          productId: row?.originalData?.result?.productId,
          secondaryProductId: row?.originalData?.result?.secondaryProductId, // ← add this
          projectId: row?._id,
        }
      });
      return;
    }

    if (!forceStep1 && row.status === "CHECK") {
      navigate('/project-results', {
        state: {
          productId: row?.originalData?.result?.productId,
          secondaryProductId: row?.originalData?.result?.secondaryProductId, // ← add this
          projectId: row?._id,
        }
      });
      return;
    }

    const stepMapping = {
      'step1': 'About',
      'step2': 'Location',
      'step3': 'Fixtures',
      'step4': 'Grease Capacity',
      'step5': 'Summary'
    };

    const lastStep = forceStep1 ? 'step1' : (row.originalData?.lastStepCompleted || 'step1');
    const targetTab = stepMapping[lastStep] || 'About';

    navigate("/createProjectForm", {
      state: {
        data: row,
        projectId: row._id,
        lastCompletedStep: lastStep,
        targetTab: targetTab,
        configurationData: row.originalData
      }
    });
  };

  const columns = [
    {
      name: "Project Name",
      selector: (row) => row.name,
      sortable: false,
      cell: (row) => (
        <span
          className="para"
          style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", gap: "4px" }}
        >
          <span
            onClick={() => handleProjectClick(row, false)}
            style={{ cursor: "pointer", wordBreak: "break-word" }}
          >
            {row.name}
          </span>
          <img
            src={Images.icon.edit}
            alt="edit name"
            style={{ cursor: "pointer", width: "16px", height: "16px", marginLeft: "4px", flexShrink: 0 }}
            onClick={(e) => {
              e.stopPropagation();
              handleRenameClick(row);
            }}
            title="Rename project"
          />
        </span>
      ),
    },
    // {
    //   name: "Result",
    //   selector: (row) => row.originalData?.result?.productName || "N/A",
    //   sortable: false,
    //   cell: (row) => {
    //     const productId = row.originalData?.result?.productId;
    //     const productName = row.originalData?.result?.productName || "N/A";

    //     return (
    //       <p
    //         className="para"
    //         onClick={() => handleProjectClick(row, true)}
    //         style={{
    //           cursor: "pointer",
    //           color: "#146ba1",
    //           wordBreak: "break-word"
    //         }}
    //       >
    //         {productName}
    //       </p>
    //     );
    //   },
    // },
    // {
    //   name: "Result",
    //   selector: (row) => row.originalData?.result?.productName || "N/A",
    //   sortable: false,
    //   cell: (row) => (
    //     <p className="para">
    //       {row.originalData?.result?.productName || "N/A"}
    //     </p>
    //   ),
    // },
    {
      name: "Created",
      selector: (row) => row.startDate,
      sortable: false,
      cell: (row) => <p className="para">{row.startDate}</p>,
    },
    // {
    //   name: "Due",
    //   selector: (row) => row.location,
    //   sortable: false,
    //   cell: (row) => <p className="para">{row.location}</p>,
    // },
    // {
    //   name: "Status",
    //   selector: (row) => row.status,
    //   sortable: false,
    //   cell: (row) => {
    //     let backgroundColor = "#cde8f9";
    //     let color = "#146ba1";

    //     if (row.status === "DRAFT") {
    //       backgroundColor = "#146ba1";
    //       color = "white";
    //     } else if (row.status === "CHECK") {
    //       backgroundColor = "#a8b5c8";
    //       color = "white";
    //     } else if (row.status === "CLOSED") {
    //       backgroundColor = "#ff6a51";
    //       color = "white";
    //     }

    //     return (
    //       <span
    //         style={{
    //           background: backgroundColor,
    //           color: color,
    //           padding: "4px 10px",
    //           borderRadius: "30px",
    //           fontWeight: 600,
    //           fontSize: "12px",
    //         }}
    //       >
    //         {row.status}
    //       </span>
    //     );
    //   },
    // },
    {
      name: "PDF",
      selector: (row) => row._id,
      sortable: false,
      cell: (row) =>
        row.projectPdf ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              cursor: "pointer",
              wordBreak: "break-word",
            }}
            onClick={() => handleDownloadPdf(row)}
          >
            <FaFilePdf size={18} color="#e74c3c" style={{ flexShrink: 0 }} />
            <span style={{ fontSize: "13px", fontWeight: 500, wordBreak: "break-word" }}>
              {row.name}
            </span>
          </div>
        ) : (
          <div style={{ display: "flex", justifyContent: "center", width: "40px" }}>
            <span style={{ fontSize: "16px", fontWeight: 600, color: "#999" }}>-</span>
          </div>
        ),
    },
    {
      name: (
        <div
          style={{ display: "flex", justifyContent: "center", width: "100%" }}
        >
          <th style={{ fontSize: "15px", fontWeight: "600" }}>Action</th>
        </div>
      ),
      selector: (row) => row._id,
      cell: (row) => {
        // Hide actions if status is CLOSED or CHECK
        if (row.status === "CLOSED" || row.status === "CHECK") {
          let message = "";
          if (row.status === "CLOSED") {
            message = "Project Closed";
          } else if (row.status === "CHECK") {
            message = "Under Review";
          }

          return (
            <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
              <span style={{ fontSize: "12px" }}>{message}</span>
            </div >
          );
        }

        return (
          <ul
            style={{
              display: "flex",
              justifyContent: "space-around",
              width: "100%",
              listStyle: "none",
              padding: "0px",
            }}
          >
            <li style={{ cursor: "pointer", width: "20px" }}>
              <img
                src={Images.icon.edit}
                alt="edit"
                onClick={() => handleProjectClick(row)}
              />
            </li>
            <li style={{ cursor: "pointer", width: "20px" }}>
              <img
                src={Images.icon.files}
                alt="file"
                onClick={() => handleCloneProject(row._id)}
              />
            </li>
            <li style={{ cursor: "pointer", width: "20px" }}>
              <img
                src={Images.icon.delete}
                alt="delete"
                onClick={() => handleDeleteClick(row._id)}
              />
            </li>
          </ul>
        );
      },
      // cell: (row) => (
      //   <ul
      //     style={{
      //       display: "flex",
      //       justifyContent: "space-around",
      //       width: "100%",
      //       listStyle: "none",
      //       padding: "0px",
      //     }}
      //   >
      //     {console.log("row", row)}
      //     <li style={{ cursor: "pointer", width: "20px" }}>
      //       <img
      //         src={Images.icon.edit}
      //         alt="edit"
      //         onClick={() => handleProjectClick(row)}
      //       />
      //     </li>
      //     <li style={{ cursor: "pointer", width: "20px" }}>
      //       <img
      //         src={Images.icon.files}
      //         alt="file"
      //         onClick={() => handleCloneProject(row._id)}
      //       />
      //     </li>
      //     <li style={{ cursor: "pointer", width: "20px" }}>
      //       <img
      //         src={Images.icon.delete}
      //         alt="delete"
      //         onClick={() => handleDeleteClick(row._id)}
      //       />
      //     </li>
      //   </ul>
      // ),
    },
  ];

  const setdATA = (row) => {
    setProjectName(row.name);
    localStorage.removeItem("pname");
    localStorage.setItem("pname", row.name);
    navigate(`/createSubmittal/${row._id}`);
  };

  const setDataTools = (row) => {
    setProjectName(row.name);
    localStorage.removeItem("pname");
    localStorage.setItem("pname", row.name);
    navigate(`/create-project-tools/${row._id}`);
  };

  const setdATABrochure = (row) => {
    localStorage.removeItem("bname");
    localStorage.setItem("bname", row.name);
    navigate(`/createBrochure/${row._id}`);
  };

  const handleEdit = (e, id, row) => {
    e.preventDefault();
    setModal(true);
    setModalID(id);
    setModalRowData(row);
  };

  const handleDeleteClick = (id) => {
    setRowId(id);
    setShow(true);
  };

  const handleCloneProject = (id) => {
    setCloneShow(true);
    setClonerowId(id);
  };

  const [modalID, setModalID] = useState("");

  // const onSortClick = (e) => {
  //   setSortByName(e.target.value);
  //   // Reset to first page when sorting changes
  //   setPage(1);
  //   getCalculatorConfigurationData(debouncedSearchTerm, 1, limit);
  // };
  const onSortClick = (e) => {
    const newSortBy = e.target.value;
    setSortBy(newSortBy);
    setPage(1); // Reset to first page when sorting changes
    // The useEffect will automatically trigger with the new sortBy value
  };

  const onAddProject = () => {
    setModal(false);
    getCalculatorConfigurationData(debouncedSearchTerm, page, limit, sortBy);
    getStatusCounts();
  };

  const crossSearch = () => {
    setSearchBar("");
    setPage(1); // Reset to first page when clearing search
  };

  const handleSearchChange = (e) => {
    setSearchBar(e.target.value);
    setPage(1); // Reset to first page when searching
  };

  // Handle page change from DataTable
  const handlePageChange = (newPage) => {
    setPage(newPage);
    // The useEffect will trigger API call with new page
  };

  // Handle rows per page change from DataTable  
  const handlePerRowsChange = (newPerPage, newPage) => {
    setLimit(newPerPage);
    setPage(newPage);
    // The useEffect will trigger API call with new limit and page
  };


  const handleRenameClick = (row) => {
    setSelectedProjectForRename(row);
    setRenameModalShow(true);
  };

  const handleRenameSave = async (newName) => {
    if (!selectedProjectForRename) return;

    setRenameLoading(true);
    try {
      const response = await API.renameCalculatorConfiguration(
        selectedProjectForRename._id,
        newName,
        token
      );

      if (response.success) {
        toast.success(response.message || "Project renamed successfully");
        setRenameModalShow(false);
        // Refresh the list
        getCalculatorConfigurationData(debouncedSearchTerm, page, limit, sortBy);
      } else {
        toast.error(response.message || "Failed to rename project");
      }
    } catch (error) {
      console.error("Rename error:", error);
      toast.error("An error occurred while renaming the project");
    } finally {
      setRenameLoading(false);
    }
  };

  const cloneProject = async () => {
    setcloneLoader(true);
    try {
      // Use the new calculator clone API
      let response = await API.cloneCalculatorConfiguration(ClonerowId, token);



      if (response.success) {
        // Refresh the list with current search and pagination
        getCalculatorConfigurationData(debouncedSearchTerm, page, limit, sortBy);
        // Update status counts
        getStatusCounts();
        // Show success message
        toast.success(response.message || "Calculator project cloned successfully");
      } else {
        toast.error(response.message || "Failed to clone calculator project");
      }
    } catch (error) {
      console.error("Clone error:", error);
      toast.error("Failed to clone calculator project");
    } finally {
      setcloneLoader(false);
      setCloneShow(false);
    }
  };

  return (
    <React.Fragment>
      <section className="quotations">
        <div className="container">
          <div className="quotations__title">
            <h1>Calculator Projects</h1>

            <div className="header__search">
              <img src={Images.icon.search} alt="" className="searchImg" />
              {searchBar ? (
                <img
                  src={cross}
                  alt=""
                  className="crossImg"
                  onClick={() => {
                    setSearchBar("");
                    setPage(1);
                  }}
                />
              ) : null}
              <input
                type="text"
                value={searchBar}
                className="form-control"
                onChange={handleSearchChange}
                placeholder="Search for projects by project/facility name, city/state, etc."
              />
            </div>
            <Button
              label="New Calculator"
              onClick={() => {
                navigate('/createProjectForm')
              }}
            />
          </div>

          <div className="quotations__content">
            <div className="quotations__sidebar">
              {/* <div className="status-cards-circular">
                <div className="status-card-circular draft">
                  <div className="card-title">DRAFT</div>
                  <div className="card-count">{statusCounts.draft}</div>
                </div>
                <div className="status-card-circular check">
                  <div className="card-title">CHECK</div>
                  <div className="card-count">{statusCounts.check}</div>
                </div>
                <div className="status-card-circular closed">
                  <div className="card-title">CLOSED</div>
                  <div className="card-count">{statusCounts.closed}</div>
                </div>
              </div> */}
            </div>

            <div className="quotations__list">
              <div className="quotations__list--wrapper">
                <div className="tableHeader">
                  <p>Projects List</p>
                  <div className="form-group">
                    <label className="title">Sort by</label>
                    <div className="position-relative">
                      <select
                        className="form-control custom-select"
                        onChange={(e) => onSortClick(e)}
                      >
                        {shortBy?.map((item) => (
                          <option key={item.id} value={item?.type}>
                            {item?.value}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="table-responsive">
                  {loader ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        minHeight: "200px",
                        alignItems: "center",
                      }}
                    >
                      <ClipLoader />
                    </div>
                  ) : (
                    <DataTable
                      pagination
                      paginationServer // Enable server-side pagination
                      paginationTotalRows={totalItems} // Total rows from API
                      paginationDefaultPage={currentPage} // Current page from API
                      paginationPerPage={limit}
                      paginationRowsPerPageOptions={[5, 10, 15, 20]}
                      onChangePage={handlePageChange} // Handle page changes
                      onChangeRowsPerPage={handlePerRowsChange} // Handle rows per page changes
                      columns={columns}
                      data={projectList} // Use projectList directly, not filteredProjects
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Delete Confirmation Modal */}
      {show && (
        <ModalC
          message="Do you want to delete this calculator project?"
          title="Delete Calculator Project"
          showmodal={true}
          handleClose={handleClose}
          deleteLoader={deleteLoader}
          handleYes={ProjectdeleteData}
        />
      )}

      {/* Clone Confirmation Modal */}
      {cloneShow && (
        <ModalC
          message="Do you want to clone this calculator project?"
          title="Clone Calculator Project"
          showmodal={true}
          handleClose={handlecloneClose}
          deleteLoader={cloneLoader}
          handleYes={cloneProject}
        />
      )}

      {quotationProjectModal && (
        <QuotationProjectModal
          show={quotationProjectModal}
          onClose={() => setQuotationProjectModal(false)}
          onSubmit={(val) => console.log("Selected location:", val)}
        />
      )}

      <CreateProjectModal
        rowID={modalRowData}
        clickProject={onCreareProject}
        clickTable={onAddProject}
        show={modal}
      />

      {renameModalShow && (
        <RenameProjectModal
          show={renameModalShow}
          onClose={() => setRenameModalShow(false)}
          onSave={handleRenameSave}
          initialName={selectedProjectForRename?.name}
          loading={renameLoading}
          isSmall={true}
        />
      )}
    </React.Fragment>
  );
};

export default CreateQuotationProjectForm;